import { Observable } from "rxjs";
import HttpClient from "@/api/HttpClient";
import { APIHosts, ApiReduxHelpers } from "@/services/reduxHelpers";
import { DeletedFilesApiResponse } from "@/features/file-management/pages/FilePage/services/files.service";

export type DeleteFileResponse = {
  success: boolean;
  message: string;
  documentId: string;
  isDeleted: boolean;
};

export type ForceDeleteResponse = {
  deletedFromDatabase: number;
  deletedFromStorage: number;
  successfulDeletions: string[];
  errors: string[];
  status: string;
  deletedAt: string;
  wasForceDelete: boolean;
};

class DeleteFileService extends ApiReduxHelpers {
  constructor() {
    super();
  }

  ApiHost = APIHosts.Upload;

  private envHeaders() {
    const env =
      (import.meta as any).env?.VITE_INERTIA_ENV ||
      localStorage.getItem("inertiaEnv") ||
      "NonProd";
    const profile =
      (import.meta as any).env?.VITE_INERTIA_PROFILE ||
      localStorage.getItem("inertiaProfile") ||
      "315";
    return {
      "X-Inertia-Env": env,
      ...(profile ? { "X-Inertia-Profile": profile } : {}),
    };
  }

  markFileAsDeleted(documentIds: string[], isDeleted: boolean = true): Observable<DeleteFileResponse> {
    return HttpClient.patch<DeleteFileResponse>(
      `${this.getHost(this.ApiHost)}/Document/multi/delete`,
      { 
        fileIds: documentIds,
        isDeleted 
      },
      {
        headers: this.envHeaders(),
      }
    );
  }

  restoreFile(documentIds: string[]): Observable<DeleteFileResponse> {
    return this.markFileAsDeleted(documentIds, false);
  }

  forceDeleteFiles(documentIds: string[]): Observable<ForceDeleteResponse> {
    const companyId = localStorage.getItem('companyId') || '1';
    return HttpClient.delete<ForceDeleteResponse>(
      `${this.getHost(this.ApiHost)}/Document/multi/force-delete?companyId=${companyId}`,
      {
        fileIds: documentIds,
        forceDelete: true
      },
      {
        headers: this.envHeaders(),
      }
    );
  }
  
  getDeletedFiles(userId: string, page: number = 1, pageSize: number = 20): Observable<DeletedFilesApiResponse> {
    return HttpClient.get<DeletedFilesApiResponse>(
      `${this.getHost(APIHosts.Upload)}/Document/deleted/user/${userId}?page=${page}&pageSize=${pageSize}`
    );
  }
}

const deleteFileService = new DeleteFileService();
export default deleteFileService;